export function roller(ctx) {
    return {
        styles: {
            main:     { ...ctx.pretty, radius: 5, text_font: 32 },
            selected: { bg_color: '#ffffff', text_color: '#000000' },
        },
    };
}
